import { BrowserRouter, Route, Routes } from "react-router-dom"
import Footer from "./components/Footer"
import Confirm from "./nav/Confirm"
import Contact from "./nav/Contact"
import Error from "./nav/Error"
import Home from "./nav/Home"
import Imprint from "./nav/Imprint"
import PreScreen from "./nav/PreScreen"
import Promoover from "./nav/Promoover"
import Terms from "./nav/Terms"
import Store from "./store/store"
import Promosoon from "./nav/Promosoon"
import axios from "axios"
import { getEnvConfig } from "./env"
import { useEffect, useState } from "react"

declare global {
	interface Window {
		Cookiebot: any
	}
}
const App = () => {
	const env = getEnvConfig()
	const [promotionStatus, setPromotionStatus] = useState<string>("")
	async function checkPromoStatus() {
		axios
			.get(env.apibase + "getPromoStatus.php")
			.then(res => {
				setPromotionStatus(res.data.status)
			})
			.catch(error => {
				setPromotionStatus("promotion.status.over")
			})
	}

	useEffect(() => {
		checkPromoStatus()
	}, [])

	//  Sun Apr 16 2023 00:00:00 UTC+0200 (Mitteleuropäische Sommerzeit)   https://time.is/de/Unix_time_converter
	let isPromoOver = parseInt(Math.floor(Date.now() / 1000).toString()) > 1756677599
	return (
		<BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
			<div>
				<Store>
					<main className="mx-auto  w-full">
						<Routes>
							{promotionStatus === "promotion.status.soon" && (
								<>
									<Route path="/" element={<Promosoon />} />
									<Route path="/promoover" element={<Promoover />} />
									<Route path="/promosoon" element={<Promosoon />} />
								</>
							)}
							{promotionStatus === "promotion.status.live" && (
								<>
									<Route path="/" element={<Home />} />
									<Route path="/danke" element={<Confirm />} />
									<Route path="/promoover" element={<Promoover />} />
									<Route path="/promosoon" element={<Promosoon />} />
								</>
							)}
							{promotionStatus === "promotion.status.over" && (
								<>
									<Route path="/" element={<Promoover />} />
									<Route path="/promoover" element={<Promoover />} />
									<Route path="/promosoon" element={<Promosoon />} />
								
								</>
							)}
							<Route path="/prescreen" element={<PreScreen />} />
							<Route path="/teilnahmebedingungen" element={<Terms />} />
							<Route path="/impressum" element={<Imprint />} />
							<Route path="/kontakt" element={<Contact />} />
							<Route path="/:err" element={<Error />} />
						</Routes>
						<Footer />
					</main>
				</Store>
			</div>
		</BrowserRouter>
	)
}

export default App
